import React, { useEffect, useState } from 'react';
import TeacherDashboard from './TeacherDashboard';
import StudentDashboard from './StudentDashboard';
import CreateOrJoinClass from './CreateOrJoinClass';
import { getClassroomRole, createClassroom, joinByCode, leaveClassroom } from '../../services/ClassroomService.ts';

const ClassroomPage = () => {
  const [role, setRole] = useState('loading'); // 'loading' | 'teacher' | 'student' | 'none'

  const loadRole = async () => {
    try {
      const data = await getClassroomRole();
      setRole(data.role);
    } catch (error) {
      console.error("Failed to load user role", error);
      setRole('none');
    }
  };

  useEffect(() => {
    loadRole();
  }, []);

  const handleCreateClass = async (className) => {
    const tempJoinCode = "Pa33w0rd"; //(does nothing)
    await createClassroom(className, tempJoinCode);
    await loadRole();
  };

  const handleJoinClass = async (joinCode) => {
    await joinByCode(joinCode);
    await loadRole();
  };

  const handleLeaveClass = async () => {
    try {
      await leaveClassroom();
    } finally {
      await loadRole();
    }
  };

  if (role === 'loading') return <div>Loading...</div>;
  if (role === 'teacher') return <TeacherDashboard />;
  if (role === 'student') return <StudentDashboard onLeave={handleLeaveClass} />;
  return <CreateOrJoinClass onCreate={handleCreateClass} onJoin={handleJoinClass} />;
};

export default ClassroomPage;